import React from 'react';
import Layout from '../../components/Layout';
import DataPage from '../../components/DataPage';

function action() {
  return {
    chunks: ['data'],
    title: 'Data sources',
    component: (
      <Layout>
        <DataPage />
      </Layout>
    ),
  };
}

export default action;
